/**
 @author xiaoye
 @date 2020/4/10 7:53 下午
 */

import store from '@/store';
import Vue from 'vue'
import {comLegend, comColor} from "../../script/comChart";
import jsonVal from "./json/data.json";

let vm = new Vue();
let vuex = store.state;

export default {
    //类型
    type: 'pie',
    //类别
    class: 'chart',
    //组件名称
    name: '饼状图',
    //排序
    sort: 3,
    //是否在多维分析展示
    viewType:true,
    //图标
    iconImg: '/img/pie.png',
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 1,
        //最小度量数量
        minDLLength: 1,
        //最大维度数量
        maxWDLength: 1,
        //最大度量数量
        maxDLLength: 1,
        //高
        dp_height: 200,
        //宽
        dp_wight: 300,
        //最小高
        dp_min_height: 50,
        //最小宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: true,
        //是否展示度量配置
        isDlConfig: true,
        //是否展示JSON配置
        isJSONConfig: true,
        //是否展示公共配置
        isComConfig: true,
        //是否展示边框
        isComBorder: true,
    },
      // 子集展示的配置项
    chilCharts: [
        {
            name: '饼状图',
            ordImg: '/img/pie.png',
            bigImg: '/img/pie.png',
            //默认配置
            chartParam: {
                pie:{
                    nradius:'0'

                }
            },
            wdParam: {},
            dlParam: {

            },
        },
        {
            name: '圆环图',
            ordImg: '/img/circlepie.png',
            bigImg: '/img/circlepie.png',
            //默认配置
            chartParam: {
                pie:{
                    nradius:'40'
                }
            },
            wdParam: {},
            dlParam: {
                stack: ''
            },
        },
        {
            name: '玫瑰图',
            ordImg: '/img/rosepie.png',
            bigImg: '/img/rosepie.png',
            //默认配置
            chartParam: {
                pie:{
                    nradius:'40',
                    roseType:'radius'

                }

            },
            wdParam: {},
            dlParam: {
                stack: ''
            },
        },
    ],
    //维度组件
    wdComponent: null,
    //维度配置参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: null,
    //度量参数
     //度量参数
    dlHandle(option) {
        return {
            //堆叠
            stack: '',
            //颜色
            color: '',
            //自定义
            customColor: false,
            //数值
            label: {
                show: false,
            },
            //主次轴
            lTAxis: 0,
        }
    },
    //配置参数
    params(option) {
        return {
            //图例配置
            legend: {
                show: true,
                position: 'top',
                //字体
                font: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    size: 14,
                },
                //间隔
                marInterval: 15,
                orient:'horizontal'
            },
            pie:{
                //数值
                label: {
                    show: false,
                    position:'outside',
                    rich: {
                        name: {
                            fontSize: 14,
                            padding: [0, 10, 0, 4],
                            fontWeight: 500,
                            align:'center'  ,
                            lineHeight:24,
                            color: vuex.dpType === 1 ? '#fff' : '#333',
                        },
                        value: {
                            fontSize: 18,
                            align:'center'  ,
                            fontWeight: 500,
                            lineHeight:24,
                            color: vuex.dpType === 1 ? '#fff' : '#333',
                        }
                    }
                },
                labelLine:{
                    show: false,
                    length: 20,
                    length2: 20,
                    lineStyle: {
                        color: "#000",
                        width: 1,
                        type: 'solid',
                    }
                },
                numType:'num',
                nradius:'0',
                wradius:'75',
                startAngle:90,
                clockwise:true,
                minAngle:0,
                roseType:false,
                name:''
            }
        }
    },
    //右侧图表配置组件列表
    configModule: [
        {
            name: '图例配置',
            component: () => import('../../comConfig/comLegend/comLegend.vue')
        },
        {
            name: '饼图配置',
            component: () => import('./config/pie_config.vue')
        },
    ],
    //接口
    JSONData: {
        //静态数组
        listDaVal: jsonVal,
        //接口参数
        params: {
            //维度
            wd: ['维度'],
            //度量
            dl: ['度量1']
        },
        //引用的组件
        jsonPonent: () => import('./json/json'),
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
        try {
            let setChart = chart.setting;
            let params = nowChart.comParam.JSONData.params;
            let dl = params.dl;
            let wd = params.wd;
            let dlStyParam = setChart.dlStyParam;
            let wdStyParam = setChart.wdStyParam;
            let head = {
                listWD: [],
                listZB: []
            };
            let dt = JSON.parse(json);
            wd.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.wdList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listWD.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comWDConfig)),
                        params: JSON.parse(JSON.stringify(wdStyParam[index] || nowChart.comPonent.wdParams))
                    };
                    data.config.alias = item;
                    setChart.wdList.push(data)
                }
            });
            dl.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.dlList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listZB.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comDLConfig)),
                        params: JSON.parse(JSON.stringify(dlStyParam[index] || nowChart.comPonent.dlParams))
                    };
                    data.config.alias = item;
                    setChart.dlList.push(data)
                }
            });
            let JkData = {
                dataTabel: {
                    dt: dt,
                    head: head
                },
                totalCount: dt.length
            };
            chart.data = JkData;
        } catch (e) {
            chart.data = {};
        }
    },
    renderBefore(chart, nowChart,dom) {
        nowChart.comConfig.gridType = 1;
        let echart = echarts.init(dom);
        echart.dispose()
        echart = null;
    },
    //渲染
    rendering(chart, nowChart, dom) {
        let dataAll = JSON.parse(JSON.stringify(chart.data.dataTabel));
        //度量维度配置
        let config = chart.setting;
        // 图表轴
        let comConfig = nowChart.comConfig;
        let echart = echarts.init(dom);
        let params = config.params;
        // 维度配置参数
        let wdParams = config.wdList;
        // 度量配置参数
        let dlParams = config.dlList;
        //维度名称
        let wd = dataAll.head.listWD;
        //度量
        let dl = dataAll.head.listZB;
        //颜色
        let colorList = JSON.parse(JSON.stringify(comColor(comConfig.colorIndex)));
        //数据
        let dataVal = dataAll.dt;
        params.pie.name=nowChart.name;
        dataVal.map((item, index) => {
            let da = {};
            for (let i in item) {
                da[i.toLowerCase()] = item[i];
            }
            dataVal[index] = da;
        });
        //
        let legendList = [];

        if (dataAll.dt.length > comConfig.valLength) {
            dataAll.dt.length = nowChart.comConfig.valLength;
        }
        //获取度量数据
        let dlVal = [];
        dl.map((i, index) => {
            let configDL = {};
            dlParams.map((c) => {
                if (c.name === i.filed) {
                    configDL = c;
                }
            });
            let node = {
                value: [],
                filedNmae: i.filed,
                aliasNmae: i.alias,
                config: configDL,
            };
            node.value = dataVal.map((item) => {
                if (configDL.params.customColor) {
                    colorList[index] = configDL.params.color;
                    return {
                        value: item[i.alias],
                        itemStyle: {
                            color: configDL.params.color
                        }
                    } || 0
                } else {
                    return item[i.alias] || 0
                }
            });

            dlVal.push(node);
            legendList.push(i.alias);
        });
        //获取维度数据
        let wdVal = [];
        wdVal = dataVal.map((item) => {
            return item[wd[0].alias];
        });
        params.pie.labelLine.length=Number(params.pie.labelLine.length);
        params.pie.labelLine.length2=Number(params.pie.labelLine.length2);
        var labelStyle = {
            show: true,
            // rich: {
            //     a: {
            //         color: '#fff',
            //         align: 'center',
            //         fontSize: 20,
            //         fontWeight: "bold"
            //     },
            //     b: {
            //         color: '#fff',
            //         align: 'center',
            //         fontSize: 10
            //     }
            // },
            // formatter: function(params) {
            //     return "{a|" + params.value + "%}\n\n" + "{b|在线统计}";
            // },
            position: 'center'

        };
        //判断数据是否超过15条  grid专用
        let isDataLengthToNum = function () {
            let min = 15;
            if (!dataAll.dt) return false;
            if (dataAll.dt.length > min) {
                return true;
            } else {
                return false;
            }
        };
        let option = {
            // tooltip: {
            //     trigger: 'item',
            //     axisPointer: {
            //         label: {
            //             show: true
            //         }
            //     }
            // },
            grid: {
                top: comConfig.grid.top + '%',
                bottom: comConfig.grid.bottom + '%',
                left: comConfig.grid.left + '%',
                right: comConfig.grid.right + '%',
                containLabel: true
            },
            legend: comLegend(params.legend, wdVal),
            color: colorList,
            series: (() => {
                var percent = 0;
                var total = 0;
                let list = [];
                dlVal.map((item) => {
                    let dlParam = item.config.params;
                    item.value.map((Num)=>{
                        total += Number(Num);
                    })
                    list.push({
                        type: this.type,
                        radius:[params.pie.nradius+'%',params.pie.wradius+'%'],
                        startAngle:params.pie.startAngle,
                        clockwise:params.pie.clockwise,
                        minAngle:params.pie.minAngle,
                        center: [comConfig.circle.left + '%', comConfig.circle.top+ '%'],
                        // roseType: nowChart.name === '玫瑰图' ? 'radius':false,
                        roseType:params.pie.roseType,
                        // selectedMode: 'single' ,
                        data:item.value,
                        name: item.aliasNmae,
                        label: {
                            show: params.pie.label.show || false,
                            position: params.pie.label.position,
                            formatter: paramsitem => {
                                percent = ((paramsitem.value / total) * 100).toFixed(0);
                                if(params.pie.numType && params.pie.numType==='string' ){
                                    return (
                                        '{name|' + paramsitem.name + '}\n{value|' +
                                        percent  + '%}'
                                    );
                                }else{
                                    return (
                                        '{name|' + paramsitem.name + '}\n{value|' +
                                        paramsitem.value + '}'
                                    );
                                }

                            },
                            emphasis: {
                                show: true, //文字至于中间时，这里需为true
                                textStyle: { //设置文字样式
                                    fontSize: '12',
                                    color:"#333"
                                }
                            },
                            rich: params.pie.label.rich
                        },
                        labelLine:params.pie.labelLine
                    });
                });
                // 获取度量维度数组
                let arr=[];
                wdVal.map((item,index)=>{
                    arr.push({name:item,value:list[0].data[index]});
                })
                list[0].data=arr;
                return list;
            })()
        };
        echart.clear();
        echart.setOption(option);
        let g_clickTime = null;
        let g_TimeFn = null;
        let g_onItemName = '';
        echart.off('click') //解决重复点击
        echart.on('click', function (params) {
            let myDate = new Date();
            if (g_clickTime === null) {
                g_clickTime = myDate.getMilliseconds();
                g_onItemName = params.name;
                g_TimeFn = setTimeout(function () {
                    window.localStorage.setItem('softContent', params.name) //存值
                    window.localStorage.setItem('softContent1', params.name)
                    echart.setOption(option);
                    xz();
                    g_clickTime = null;
                }, 300);
            } else {
                clearTimeout(g_TimeFn);
                if (Math.abs(myDate.getMilliseconds() - g_clickTime) < 300 && g_onItemName === params.name) {
                    // 双击操作
                    window.localStorage.setItem('dbl', params.name) //存值
                    sz();
                }
                g_clickTime = null;
            }
        });
        echart.resize()
    }
}
